/* Mặc Atelier: phần dùng chung cho trang Sản phẩm và trang Bộ sưu tập.
   Trang chủ có kịch bản riêng vì nó phải lo cả đoạn phim cuộn. */
(function(){
'use strict';

/* ============================================================
   SỬA Ở ĐÂY: thay bằng đường dẫn thật của Mặc Atelier.
   Cùng bộ với phần khai báo trong index.html.
   ============================================================ */
var BRAND = {
  messenger    : 'https://m.me/mawcatelierr',
  instagram    : 'https://ig.me/m/mac.atelierr',
  facebookPage : 'https://www.facebook.com/mawcatelierr',
  instagramPage: 'https://www.instagram.com/mac.atelierr'
};

/* Trang đặt hàng cần dùng lại đúng bộ đường dẫn này, nên đưa ra ngoài một lần. */
window.MAC_BRAND = BRAND;

var $  = function(s,r){ return (r||document).querySelector(s); };
var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
function reducedMotion(){ return matchMedia('(prefers-reduced-motion: reduce)').matches; }

/* ---------- thanh điều hướng, chỉ ghi khi có thay đổi ---------- */
var nav = $('.nav'), navStuck = false;
function onScroll(){
  var s = window.scrollY > 40;
  if(s !== navStuck){ navStuck = s; nav.classList.toggle('stuck', s); }
}
window.addEventListener('scroll', onScroll, {passive:true});
onScroll();

/* ---------- vào màn hình, có thứ tự, rồi cho độ trễ nghỉ hưu ---------- */
if('IntersectionObserver' in window){
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      e.target.classList.add('in');
      setTimeout(function(){ e.target.classList.add('done'); }, 1500);
      io.unobserve(e.target);
    });
  },{threshold:.12, rootMargin:'0px 0px -8% 0px'});
  $$('.stack').forEach(function(el){ io.observe(el); });

  var liveIo = new IntersectionObserver(function(es){
    es.forEach(function(e){ e.target.classList.toggle('live', e.isIntersecting); });
  },{rootMargin:'10% 0px'});
  $$('section, header, footer').forEach(function(el){ liveIo.observe(el); });
} else {
  $$('.stack').forEach(function(el){ el.classList.add('in','done'); });
  $$('section, header, footer').forEach(function(el){ el.classList.add('live'); });
}

/* ---------- tạm dừng mọi chuyển động khi tab bị ẩn ---------- */
var pauseStyle = document.createElement('style');
pauseStyle.textContent = 'body.paused *, body.paused *::before, body.paused *::after{animation-play-state:paused !important}';
document.head.appendChild(pauseStyle);
document.addEventListener('visibilitychange', function(){
  document.body.classList.toggle('paused', document.hidden);
});

/* ---------- giảm chuyển động: ghim mọi thứ ở trạng thái cuối, theo cả hai chiều ---------- */
function pinToFinalStates(){ $$('.stack').forEach(function(el){ el.classList.add('in','done'); }); }
if(reducedMotion()) pinToFinalStates();
var rmq = matchMedia('(prefers-reduced-motion: reduce)');
if(rmq.addEventListener) rmq.addEventListener('change', function(e){ if(e.matches) pinToFinalStates(); });

/* ---------- đường dẫn thương hiệu ---------- */
function setHref(sel, url){ var e = $(sel); if(e) e.href = url; }
setHref('#dmLink',  BRAND.messenger);
setHref('#igLink',  BRAND.instagram);
setHref('#footFb',  BRAND.facebookPage);
setHref('#footIg',  BRAND.instagramPage);
var yr = $('#yr'); if(yr) yr.textContent = new Date().getFullYear();

/* ---------- chép vào bộ nhớ tạm, có bản dự phòng cho trình duyệt cũ ---------- */
function copyText(t, done){
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(t).then(done, done);
    return;
  }
  var ta = document.createElement('textarea');
  ta.value = t; ta.setAttribute('readonly','');
  ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
  document.body.appendChild(ta); ta.select();
  try{ document.execCommand('copy'); }catch(err){}
  document.body.removeChild(ta);
  done();
}

/* ---------- nút hỏi từng mẫu ---------- */
var toast = $('#toast'), toastTimer = null;
function showToast(){
  if(!toast) return;
  toast.classList.add('on');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function(){ toast.classList.remove('on'); }, 3200);
}
$$('button.ask').forEach(function(btn){
  btn.addEventListener('click', function(){
    var msg = 'Xin chào Mặc Atelier, tôi muốn hỏi mẫu ' + btn.getAttribute('data-model') +
              ' giá ' + btn.getAttribute('data-price') + '.';
    copyText(msg, function(){
      showToast();
      window.open(BRAND.messenger, '_blank', 'noopener');
    });
  });
});

/* ---------- form tư vấn size. Không có máy chủ nào ở đây, nên nói đúng sự thật. ---------- */
var form = $('#sizeForm'), sentBox = $('#sentBox'), formErr = $('#formErr');
if(form){
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var ten = form.ten.value.trim(), lienhe = form.lienhe.value.trim();
    if(!ten || !lienhe){
      formErr.classList.add('on');
      (!ten ? form.ten : form.lienhe).focus();
      return;
    }
    formErr.classList.remove('on');
    var msg = 'Xin chào Mặc Atelier, tôi muốn được tư vấn size.\n' +
              'Tên: ' + ten + '\n' +
              'Liên hệ: ' + lienhe + '\n' +
              'Quan tâm: ' + form.mon.value + '\n' +
              'Số đo: ' + (form.sodo.value.trim() || 'chưa có');
    copyText(msg, function(){
      form.classList.add('gone');
      sentBox.classList.add('on');
      sentBox.scrollIntoView({block:'center', behavior: reducedMotion() ? 'auto' : 'smooth'});
      $('#dmLink').focus();
    });
  });
}

})();
